import type { QueryClient } from '@tanstack/react-query';

export const DIGEST_QUERY_KEY = ['digest'] as const;

/** Retire restricted digest payloads before a converted account opens them. */
export async function clearDigestQueryCache(queryClient: QueryClient): Promise<void> {
    await queryClient.cancelQueries({
        queryKey: DIGEST_QUERY_KEY,
        exact: false,
    });
    queryClient.removeQueries({
        queryKey: DIGEST_QUERY_KEY,
        exact: false,
    });
}
